import { LogOutIcon } from 'lucide-react'

import { getCurrentAppIdentifier } from '../config/apps'
import { compatibleMemberships } from '../store/activeOrg'
import { useAuthStore } from '../store/auth'
import { orgTypeColors, orgTypeLabels } from './OrgSwitcher'

/**
 * Tela "Em qual organização você quer atuar?" (#1145).
 *
 * Aparece depois do login e antes do dashboard quando o usuário tem mais de uma
 * organização compatível com o portal e a aba não trouxe sinal explícito (?org= ou
 * sessionStorage). A lista é só `memberships` do /auth/me, que no white-label do EC o
 * backend já recorta pelo escopo da revenda: organização de fora não chega aqui, nem o nome.
 * Sem "lembrar minha escolha" — a escolha vale para esta aba.
 */
export function OrgChoicePage() {
  const memberships = useAuthStore((s) => s.memberships)
  const chooseOrganization = useAuthStore((s) => s.chooseOrganization)
  const logout = useAuthStore((s) => s.logout)

  const options = compatibleMemberships(memberships, getCurrentAppIdentifier())
    .slice()
    .sort((a, b) => a.organization_name.localeCompare(b.organization_name, 'pt-BR'))

  return (
    <main className="flex min-h-screen items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow">
        <h1 className="mb-1 text-xl font-semibold text-gray-900">
          Em qual organização você quer atuar?
        </h1>
        <p className="mb-4 text-sm text-gray-600">
          Você pertence a mais de uma organização. Para trocar depois, use o seletor de organização
          no menu.
        </p>
        <ul className="space-y-2">
          {options.map((m) => (
            <li key={m.organization_id}>
              <button
                type="button"
                onClick={() => chooseOrganization(m.organization_id)}
                className="flex w-full items-center justify-between gap-3 rounded-lg border border-gray-200 px-4 py-3 text-left transition-colors hover:bg-gray-50 focus:ring-2 focus:ring-gray-400 focus:outline-none"
              >
                <span className="min-w-0">
                  <span className="block truncate text-sm font-medium text-gray-900">
                    {m.organization_name}
                  </span>
                  <span className="block truncate text-xs text-gray-500">
                    {m.roles.join(', ') || 'Membro'}
                  </span>
                </span>
                <span
                  className={`${orgTypeColors[m.organization_type || ''] || 'bg-gray-500'} rounded px-1.5 py-0.5 text-[10px] font-bold text-white`}
                >
                  {orgTypeLabels[m.organization_type || ''] || '?'}
                </span>
              </button>
            </li>
          ))}
        </ul>
        <button
          type="button"
          onClick={() => logout()}
          className="mt-4 inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900"
        >
          <LogOutIcon className="h-4 w-4" />
          Sair
        </button>
      </div>
    </main>
  )
}
